import HttpResponse from "../../../../../../utils/http/http.response";

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContractTaxiDetails =
  {
    displayName: string;
  };

export enum BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContract =
  {
    model: BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel;
    distanceRate: number;
    haltingTimeRate: number;
    haltingTimeAfterMinutes: number;
    producerTaxi: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContractTaxiDetails;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrder =
  {
    cargoOrder: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrderCargoOrder;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingAction =
  {
    id: string;
    contract: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContract;
    transportingOrder: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrder;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  haltingAmount: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonusFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonusOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonus =

    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonusFavorableDistance
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonusOther;

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenalty =

    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyWrongRoute
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyBeingLate
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyIncompatibleCar
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenaltyOther;

export type BillingsOrderForwardTaxiTaxiRecalculateResponseDataContribution =
  | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionBonus
  | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionPenalty;

export enum BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderForwardTaxiTaxiRecalculateResponseData = {
  orderForwardingAction: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingAction;
  billingNodes: BillingsOrderForwardTaxiTaxiRecalculateResponseDataNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryId: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  status: BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus;
  passengers: string[];
};

type BillingsOrderForwardTaxiTaxiRecalculateResponse =
  HttpResponse<BillingsOrderForwardTaxiTaxiRecalculateResponseData>;

export default BillingsOrderForwardTaxiTaxiRecalculateResponse;
